<div class="led-container">
  <div class="action-wrapper">
    <p>Easily manage and update a legal entity's documents.</p>
    @if (canUploadDocuments) {
      <app-az-button
        [label]="'Replace File'"
        [icon]="'upload'"
        (click)="openModal()"
      ></app-az-button>
    }
  </div>

  <div *ngIf="loading" class="loading-overlay" aria-live="polite" aria-label="Loading documents">
    <div class="overlay-content">
      <app-spinner [display]="true" [diameter]="48" aria-label="Loading"></app-spinner>
      <span>Loading documents…</span>
    </div>
  </div>

  <app-az-table
    [data]="documents"
    [columns]="columns"
    [actions]="actions"
    [emptyMessage]="'No documents available for this legal entity.'"
    (rowClick)="onRowClick($event)"
  ></app-az-table>
</div>

<app-az-document-update-modal
  [isOpen]="isModalOpen"
  [documentTypes]="documentTypes"
  [isUploading]="uploading"
  (close)="closeModal()"
  (upload)="handleUpload($event)"
></app-az-document-update-modal>

<app-status-change-modal
  [isOpen]="isStatusModalOpen"
  [title]="'Document Upload'"
  [initialState]="'success-with-message'"
  (close)="closeStatusModal()"
></app-status-change-modal>
